
import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import { OperationsManagementService } from "@/api/service-proxies";
import SchoolSelector from './components/school-selector.vue';
import moment from "moment";
import { exportWithExcelJS } from '@/lib/exportExcel'
import { formatJson } from '@/lib'

@Component({
  name: "SchoolAnalysisMainTable",
  components: { SchoolSelector }
})
export default class ScreenTv extends Vue {
  pickerOptions = {
    disabledDate(time: Date): boolean {
      return time.getTime() > Date.now(); // 禁用未来日期
    },
    shortcuts: [
      { text: '今天', onClick(picker: any) { picker.$emit('pick', new Date()); } },
      {
        text: '昨天',
        onClick(picker: any) {
          const d = new Date();
          d.setTime(d.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', d);
        }
      },
      {
        text: '一周前',
        onClick(picker: any) {
          const d = new Date();
          d.setTime(d.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', d);
        }
      }
    ]
  };
  // 接口服务实例
  OperationPointsService = new OperationsManagementService();
  value1 = moment().format('YYYY-MM-DD');
  schoolName = "";
  schoolType="";
  responsibleName = "";//负责人
  isShowOffDevice = null;
  tenantRegion = "";//区域
  dateday: moment.Moment = moment().add(8, 'hours');
  // 表格数据
  tableList: any[] = [];
  // 表格加载状态
  isTableLoading = false;
  nowDay = moment().add(8, 'hours').format("YYYY年MM月DD日");
  isExportLoading = false
  isShowSearch = true
  mounted() {
    this.getTableData();
  }

  beforeDestroy() {
  }

async exportSchoolAnalysis() {
  if (this.tableList.length == 0) {
    this.$message.error('数据未加载成功，请稍后重试!');
    return;
  }

  this.isExportLoading = true;
  try {
    const header = [
      '学校名称', '学校类型','负责人', '区域', '经营类型', '收费类型', '应到人数', '实到人数', '未到人数',
      '请假人数', '实到占比', '设备在线', '设备离线', '微信电话在线', '微信电话离线','七天收入', '七天打电话数','未绑定微信电话数', '未录人脸数',
      '未绑定家长数', '非会员人数'
    ];

    const filterVal = [
      'tenantName', 'schoolType','responsibleName', 'tenantRegion', 'businessType', 'billingType',
      'shouldArriveNum', 'actualArriveNum', 'notInSchoolNum', 'leaveNum', 'rate', 'onLineDeviceCount', 'deviceOffLineCount',
      'wxPhoneOnLineCount', 'wxPhoneOffLineCount', 'moneySevenDay','wxCallServenDay', 'parentNotBindWxCallNum', 'notFaceImgNum',
      'noBindParentNum', 'noVipCount'
    ];

    let data = formatJson(filterVal, this.tableList);

    // 在 formatJson 之后转换数据
    data = data.map((row: any[]) => {
      // 根据 filterVal 中字段的位置来转换
      const billingTypeIndex = filterVal.indexOf('billingType');
      const businessTypeIndex = filterVal.indexOf('businessType');

      if (billingTypeIndex !== -1) {
        row[billingTypeIndex] = row[billingTypeIndex] == 0 ? '自营' : row[billingTypeIndex] == 1 ? '代理' : '重点保障';
      }
      if (businessTypeIndex !== -1) {
        row[businessTypeIndex] = row[businessTypeIndex] == 0 ? 'C端' : row[businessTypeIndex] == 1 ? 'B端' : 'C端B端';
      }

      return row;
    });

    await exportWithExcelJS(header, data, '各学校数据');
  } catch (error) {
    console.error('导出失败:', error);
    this.$message.error('导出失败，请重试');
  } finally {
    this.isExportLoading = false;
  }
}
  // 获取表格数据（核心接口请求）
  getTableData(): Promise<void> {
    this.isTableLoading = true;
    return this.OperationPointsService.getStudentDailyAttendanceStaticEveryDay(this.value1, this.responsibleName, this.schoolName, this.tenantRegion, this.isShowOffDevice,this.schoolType)
      .then((result: any) => {
        this.tableList = result;
        console.log(`表格数据加载完成，共 ${result.length} 条`);
      })
      .catch((error: any) => {
        this.$message.error('请求失败，请重试');
        console.error('数据请求错误:', error);
      })
      .finally(() => {
        this.isTableLoading = false;
      });
  }

}
